<script>
import formatFileSize from 'linna/util/formatFileSize'

import StyledButton from '../snippets/StyledButton'

export default {
  name: 'FileListItem',

  components: {
    StyledButton
  },

  props: {
    file: {
      type: Object,
      required: true
    }
  },

  data () {
    return {}
  },

  computed: {

    size () {
      return formatFileSize(this.file.size)
    }

  }

}
</script>

<template>
  <div class="c-file-list-item">
    <styled-button
      :to="{
        name: 'file',
        params: {
          fileSlug: file.fileSlug
        }
      }"
      class="c-file-list-item-content"
    >

      <div class="c-file-list-item-type">
        {{ file.typeName }}
      </div>

      <div class="c-file-list-item-name">
        {{ file.name }}{{ file.fileExtension }}
      </div>

      <div class="c-file-list-item-locked">
        {{ file.locked }}
      </div>

      <div class="c-file-list-item-size">
        {{ size }}
      </div>

    </styled-button>
  </div>
</template>

<style lang="scss">

.c-file-list-item-content {
  width: 100%;

  .c-click-button-content {
    @include flex;
    @include flex-center;
    width: 100%;
  }

}

.c-file-list-item-type,
.c-file-list-item-size {
  @include flex-fixed;
}

.c-file-list-item-type {
  width: 4rem;
}

.c-file-list-item-name {
  @include flex-fluid;
}

.c-file-list-item-size {
  @include align-right;
  width: 8rem;
}

</style>
